import angular from 'angular';
import booksMenu from '../../menu/Menu';
import ngRoute from 'angular-route';
/** Services */
import { RegProductFormsService } from './services/RegProductForms';

export default angular
  .module('regProductForms', [booksMenu, ngRoute])
  .controller('regProductFormsController', MainController)
  .service('RegProductForms', RegProductFormsService)
  .name;

/*****************************************************************************
 * Controller: regProductForms
 *
 * Main controller for the registration product form app
 *****************************************************************************/
/* @ngInject */ function MainController(
  $scope,
  $injector,
  RegProductForms,
  BusyScreen,
  Alert
) {
  /*-----------------------------*/
  /* Set functions on controller */
  /*-----------------------------*/
  $scope.itemsGrid = $injector.invoke(itemsGrid, null, { $scope: $scope });
  $scope.printForm = $injector.invoke(printForm, null, { $scope: $scope });

  /*-------------------*/
  /* Item grid options */
  /*-------------------*/
  /* @ngInject */ function itemsGrid(uiGridConstants) {
    var itemGrid = {
      enableColumnMenus: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableFiltering: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectAll: true,
      saveFilter: true,
      saveSort: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $scope.itemsGrid.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          field: 'name',
          displayName: 'Name',
          cellTooltip: true
        },
        {
          field: 'shortDescription',
          displayName: 'Description',
          cellTooltip: true
        },
        {
          field: 'category',
          displayName: 'Category',
          cellTooltip: true
        }
      ]
    };
    return itemGrid;
  }

  /***************************************************************************
   * printForm */
  /**
   * Prints the registration product form in a new window.
   ***************************************************************************/
  /* @ngInject */ function printForm(Alert, Session, Tools) {
    return function () {
      /*------------------------------------------------------------*/
      /* Get the list of products that have been selected to print. */
      /*------------------------------------------------------------*/
      var selectedAccounts =
        $scope.itemsGrid.api.grid.api.selection.getSelectedRows();

      if (selectedAccounts.length < 1)
        return Alert.error(
          'Please select at least one product',
          'No Selection'
        );

      /*-----------------------------------------*/
      /* Selected product ID's in string format. */
      /*-----------------------------------------*/
      var productIds = selectedAccounts
        .map(function (account) {
          return account.id;
        })
        .toString();

      /*----------------*/
      /* Request object */
      /*----------------*/
      var requestInfo = {
        productIds: productIds,
        useStudentName: true,
        reportFormat: 'PDF'
      };

      /*--------------------------*/
      /* Submit the post request. */
      /*--------------------------*/
      JSON.postTo(
        requestInfo,
        Session.getSessionURL('/RegistrationProductForm.aspx'),
        'request'
      );
    };
  }

  /*------------------------------------*/
  /* Get the list of items for the org. */
  /*------------------------------------*/
  BusyScreen.promise(
    RegProductForms.getProductList().then(function (resp) {
      if (resp.length < 1)
        Alert.confirm('No products were found', 'Products', {
          confirmButtonText: 'OK',
          showCancelButton: false
        });

      $scope.itemsGrid.data = resp.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
    })
  );
}
